<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="사용자정보" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-plant
                  required
                  :editable="false"
                  type="edit"
                  name="plantCd"
                  v-model="popupParam.plantCd">
                </c-plant>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-field 
                  :editable="false"
                  :disabled="true"
                  :data="popupParam"
                  deptValue="deptCd"
                  type="dept_user" 
                  label="부서/사용자" 
                  name="userId" 
                  v-model="popupParam.userId" />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  :editable="false"
                  :disabled="true"
                  label="페널티 총점"
                  name="penaltyPoint"
                  type="number"
                  v-model="penaltyPoint">
                </c-text>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-table
            ref="table"
            title="페널티 이력"
            :columns="grid.columns"
            :merge="grid.merge"
            :data="grid.data"
            gridHeight="400px"
            :filtering="false"
            :columnSetting="false"
            :usePaging="false"
            :editable="editable"
            :hideBottom="true"
            :isExcelDown="false"
            selection="multiple"
            rowKey="userPenaltyId"
          >
            <template slot="table-button">
              <q-btn-group outline>
                <c-btn v-if="editable" label="추가" icon="add" @btnClicked="addPenalty" />
                <c-btn v-if="editable" label="저장" icon="save" @btnClicked="savePenalty" />
                <c-btn v-if="editable" label="삭제" icon="remove" @btnClicked="removePenalty" />
              </q-btn-group>
            </template>
          </c-table>
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'proceedings-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        plantCd: null,
        deptCd: '',
        userId: '',
        userName: '',
        isSearch: false,
      }),
    },
  },
  data() {
    return {
      editable: false,
      penaltyPoint: 0,
      grid: {
        merge: [
          { index: 0, colName: 'mergeGroup' },
        ],
        columns: [
          {
            name: 'sopNameDate',
            field: 'sopNameDate',
            label: '안전보건팀 패트롤명[작업일]',
            style: 'width: 250px',
            align: 'center',
          },
          {
            name: 'penaltyPoint',
            field: 'penaltyPoint',
            label: '페널티',
            style: 'width: 100px',
            type: 'number',
            required: true,
            align: 'right',
          },
          {
            name: 'penaltyDt',
            field: 'penaltyDt',
            label: '페널티 부과일',
            align: 'center',
            type: 'date',
            required: true,
            style: 'width: 150px',
          },
          {
            name: 'penaltyReason',
            field: 'penaltyReason',
            label: '페널티 부과 사유',
            type: 'text',
            align: 'left',
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.penalty.get.url;
      this.saveUrl = transactionConfig.sai.penalty.save.url;
      this.deleteUrl = transactionConfig.sai.penalty.delete.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.userId) {
        this.$http.url = this.listUrl;
        this.$http.param = {userId: this.popupParam.userId};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid.data = _result.data;
          this.getSum(_result.data);
        },);
      }
    },
    getSum(_data) {
      this.penaltyPoint = 0;
      this.$_.forEach(_data, item => {
        this.penaltyPoint += item.penaltyPoint;
      });
    },
    addPenalty() {
      this.grid.data.splice(0, 0, {
        editFlag: 'C',
        userPenaltyId: uid(),  // 벌점부과 일련번호
        userId: this.popupParam.userId,  // 사용자ID
        penaltyDt: this.$comm.getToday(),  // 벌점부과일
        penaltyPoint: null,  // 벌점
        penaltyReason: '',  // 벌점부과 사유
        sopNameDate: '직접추가',
      });
    },
    removePenalty() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              // this.getList();
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              
              this.$_.forEach(selectData, item => {
                this.grid.data = this.$_.reject(this.grid.data, item);
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();
              this.getSum(this.grid.data);
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    savePenalty() {
      let checkItem = ['penaltyDt','penaltyPoint']
      let isConti = true;
      this.$_.forEach(this.grid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [페널티 부과일, 페널티]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.grid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        this.$_.forEach(saveData, item => {
          item.regUserId = this.$store.getters.user.userId;
          item.chgUserId = this.$store.getters.user.userId;
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.saveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                window.getApp.$emit('APP_REQUEST_SUCCESS');
                this.getDetail();
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
  }
};
</script>
